<template>
  <ul class="c-image-fader">
    <transition-group>
      <li
        v-for="(item, index) in items"
        v-show="index === currentIndex"
        :key="index"
        @click="$emit('fader-image-clicked', index)"
      >
        <img :src="item.src" :alt="item.alt" />
      </li>
    </transition-group>
  </ul>
</template>

<script>
export default {
  name: 'ComponentsImageFader',
  props: {
    items: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      currentIndex: 0,
    }
  },
  mounted() {
    this.intervalId = setInterval(() => {
      this.currentIndex = (this.currentIndex + 1) % (this.items.length || 1)
    }, 5000)
  },
  beforeUnmount() {
    clearInterval(this.intervalId)
  },
}
</script>

<style lang="scss" scoped>
@use '~/scss/generic/mixins';
@use '~/scss/modules/teikibin';

.c-image-fader {
  height: 100vw;
  position: relative;

  @include mixins.screen-desktop {
    height: teikibin.$width-content;
  }

  > * {
    position: absolute;
    top: 0;

    &.v-enter-active,
    &.v-leave-active {
      transition: opacity 2s ease;
    }

    &.v-enter-from,
    &.v-leave-to {
      opacity: 0;
    }
  }
}
</style>
